"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Insights
 * OpenApi specification for the Insights.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiAreaChartKindEnumToJSON = exports.MultiAreaChartKindEnumFromJSONTyped = exports.MultiAreaChartKindEnumFromJSON = exports.MultiAreaChartKindEnum = void 0;
/**
 *
 * @export
 */
exports.MultiAreaChartKindEnum = {
    MultiAreaChart: 'multiAreaChart'
};
function MultiAreaChartKindEnumFromJSON(json) {
    return MultiAreaChartKindEnumFromJSONTyped(json, false);
}
exports.MultiAreaChartKindEnumFromJSON = MultiAreaChartKindEnumFromJSON;
function MultiAreaChartKindEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MultiAreaChartKindEnumFromJSONTyped = MultiAreaChartKindEnumFromJSONTyped;
function MultiAreaChartKindEnumToJSON(value) {
    return value;
}
exports.MultiAreaChartKindEnumToJSON = MultiAreaChartKindEnumToJSON;
